import React, { useState } from "react";
import { Row, DeleteRowButton } from "../styles";
import Input from "../../../../../components/inputField";
import { Bid, ESubInfo } from "../types";
import { FunctionalButton } from "../../../../../components/functionalButton";
import { StyledQuestion } from "../../styles";
import {
  PlusSignArea,
  StyledAddText,
} from "../../../../../components/commonCategories/styles";
import PlusSign from "../../../../../assets/onBoarding/plusSign";
import DeleteIcon from "../../../../../assets/preQualifyIcons/deleteIcon";

type BidInfoSectionProps = {
  esubData: ESubInfo;
  setESubData: (field: string, value: string) => void;
  isMobile: boolean;
  handleNext: () => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: number) => void;
};

export const BidInfoSection = ({
  esubData,
  setESubData,
  isMobile,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
}: BidInfoSectionProps) => {
  console.log("Esub data: ", esubData);
  const [additionalBids, setAdditionalBids] = useState<Bid[]>([]);

  const formatNumberWithCommas = (value: string): string => {
    if (!value) return "";
    
    const cleanValue = value.replace(/[^\d.]/g, "");
    
    if (cleanValue.includes(".")) {
      const [wholePart, decimalPart] = cleanValue.split(".");
      const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formattedWhole}.${decimalPart}`;
    }
    
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const removeCommas = (value: string): string => {
    return value.replace(/,/g, "");
  };

  const convertDateFormat = (dateString: string): string => {

    if (isValidYearMonthDayFormat(dateString)) {
      return dateString;
    }
    const parts = dateString.split("/");

    if (parts.length !== 3) {
      console.log("date string: ", dateString);
      console.error("Invalid date format. Expected MM/dd/yyyy");
      return ""; 
    }

    const [month, day, year] = parts;

    if (isNaN(Number(month)) || isNaN(Number(day)) || isNaN(Number(year))) {
      console.error("Invalid date format. All parts must be numeric");
      return ""; 
    }

    const paddedMonth = month.padStart(2, "0");
    const paddedDay = day.padStart(2, "0");

    return `${year}-${paddedMonth}-${paddedDay}`;
  };

  const isValidYearMonthDayFormat = (dateString: string): boolean => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!regex.test(dateString)) {
      return false;
    }

    const [year, month, day] = dateString.split("-").map(Number);

    const date = new Date(year, month - 1, day); 

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  };

  const handleAddAdditionalBid = () => {
    // Limit total bidders to 5 (3 fixed + 2 additional)
    if (additionalBids.length < 2) {
      setAdditionalBids([
        ...additionalBids,
        {
          bidderName: "",
          amount: "",
        },
      ]);
    }
  };

  const handleUpdateAdditionalBidderAmount = (index, value) => {
    setAdditionalBids((additionalBids) => {
      return additionalBids.map((bid, i) => {
        if (index === i) {
          return {
            ...bid,
            amount: value,
          };
        }

        return bid;
      });
    });
  };

  const handleUpdateAdditionalBidderName = (index, value) => {
    setAdditionalBids((additionalBids) => {
      return additionalBids.map((bid, i) => {
        if (index === i) {
          return {
            ...bid,
            bidderName: value,
          };
        }

        return bid;
      });
    });
  };

  const handleDeleteAdditionalBidder = (index) => {
    setAdditionalBids((additionalBids) => {
      return additionalBids.filter((_, i) => i !== index);
    });
  };

  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">
        How was this Project Awarded?
      </StyledQuestion>
      <Row>
        <Input
          label="Date Bid Awarded"
          type="date"
          fontSize="18px"
          labelSize="12px"
          value={convertDateFormat(esubData?.bond_details?.as_at_date ?? "")}
          setValue={(e) => setESubData("bond_details.as_at_date", e)}
          backgroundColor={undefined}
          color={undefined}
          placeholder={undefined}
          validateFunc={undefined}
          style={undefined}
          withoutMargin={undefined}
          marginTop={undefined}
          id={undefined}
          labelWeight={undefined}
          textAreaHeight={undefined}
          borderColor={undefined}
          autoComplete={undefined}
          noCheckIcon={undefined}
          cancelIcon={undefined}
          noErrorBorder={undefined}
          ref={undefined}
          hasError={undefined}
          inputId={undefined}
          disabled={undefined}
          width={undefined}
          paddingRight={undefined}
          paddingLeft={undefined}
          onBlur={undefined}
          showError={undefined}
          readOnly={undefined}
          marginRight={undefined}
        />
      </Row>

      <Row>
        <Input
          label="Contract Price"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={formatNumberWithCommas(esubData?.bond_details?.contract_price ?? "")}
          setValue={(e) => setESubData("bond_details.contract_price", removeCommas(e))}
          backgroundColor={undefined}
          color={undefined}
          placeholder={undefined}
          validateFunc={undefined}
          style={undefined}
          withoutMargin={undefined}
          marginTop={undefined}
          id={undefined}
          labelWeight={undefined}
          textAreaHeight={undefined}
          borderColor={undefined}
          autoComplete={undefined}
          noCheckIcon={undefined}
          cancelIcon={undefined}
          noErrorBorder={undefined}
          ref={undefined}
          hasError={undefined}
          inputId={undefined}
          disabled={undefined}
          width={undefined}
          paddingRight={undefined}
          paddingLeft={undefined}
          onBlur={undefined}
          showError={undefined}
          readOnly={undefined}
          marginRight={undefined}
        />
        <Input
          label="Bid Bond Amount"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={formatNumberWithCommas(esubData?.bond_details?.bid_bond_amount ?? "")}
          setValue={(e) => setESubData("bond_details.bid_bond_amount", removeCommas(e))}
          backgroundColor={undefined}
          color={undefined}
          placeholder={undefined}
          validateFunc={undefined}
          style={undefined}
          withoutMargin={undefined}
          marginTop={undefined}
          id={undefined}
          labelWeight={undefined}
          textAreaHeight={undefined}
          borderColor={undefined}
          autoComplete={undefined}
          noCheckIcon={undefined}
          cancelIcon={undefined}
          noErrorBorder={undefined}
          ref={undefined}
          hasError={undefined}
          inputId={undefined}
          disabled={undefined}
          width={undefined}
          paddingRight={undefined}
          paddingLeft={undefined}
          onBlur={undefined}
          showError={undefined}
          readOnly={undefined}
          marginRight={undefined}
        />
      </Row>
      <Row>
        <Input
          label="2nd Bidder Name"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={esubData?.bond_details?.bidder2_name || ""}
          setValue={(e) => setESubData("bond_details.bidder2_name", e)}
        />
        <Input
          label="Bid Amount"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={formatNumberWithCommas(esubData?.bond_details?.bidder2_bid_amount || "")}
          setValue={(e) => setESubData("bond_details.bidder2_bid_amount", removeCommas(e))}
        />
      </Row>
      <Row>
        <Input
          label="3rd Bidder Name"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={esubData?.bond_details?.bidder3_name || ""}
          setValue={(e) => setESubData("bond_details.bidder3_name", e)}
        />
        <Input
          label="Bid Amount"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={formatNumberWithCommas(esubData?.bond_details?.bidder3_bid_amount || "")}
          setValue={(e) => setESubData("bond_details.bidder3_bid_amount", removeCommas(e))}
        />
      </Row>
      <>
        {additionalBids.map((bid: Bid, index: number) => {
          return (
            <Row key={index}>
              <Input
                label={`${index + 4}th Bidder Name`}
                type="text"
                fontSize="18px"
                labelSize="12px"
                value={additionalBids[index]?.bidderName ?? "-"}
                setValue={(e) => handleUpdateAdditionalBidderName(index, e)}
              />
              <Input
                label="Bid Amount"  
                type="text"
                fontSize="18px"
                labelSize="12px"
                value={formatNumberWithCommas(additionalBids[index].amount || "")}
                setValue={(e) => handleUpdateAdditionalBidderAmount(index, removeCommas(e))}
              />
              <DeleteRowButton onClick={() => handleDeleteAdditionalBidder(index)}>
                <DeleteIcon />
              </DeleteRowButton>
            </Row>
          );
        })}
        {additionalBids.length < 2 && (
          <PlusSignArea usePlusIcon>
            <>
              <div style={{ marginTop: "14px", marginRight: "10px" }}>
                <PlusSign onAdd={handleAddAdditionalBid} enableAdd />
              </div>
              <StyledAddText onClick={handleAddAdditionalBid} enableAdd>
                Add Bidder
              </StyledAddText>
            </>
          </PlusSignArea>
        )}
      </>
      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => {
          handleNext();
          setPanel(4);
        }}
        width={undefined}
        height={undefined}
        isReversedColor={undefined}
        marginRight={undefined}
        marginLeft={undefined}
        marginTop={"40px"}
        marginBottom={undefined}
        fontSize={undefined}
        disabled={undefined}
        icon={undefined}
        hasBoxShadow={undefined}
        frontIcon={undefined}
        weight={undefined}
        borderColor={undefined}
        selected={undefined}
      />
    </>
  );
};
